export default __webpack_public_path__ + "static/media/heartFilled.458f4bf2.svg";